import React from 'react';
import styled from 'styled-components';
import Spinner from 'packages/ui/Spinner';

const Wrapper = styled.div`
  align-items: center;
  background-color: #fff;
  color: #bbb;
  display: flex;
  font-size: 18px;
  height: 100vh;
  justify-content: center;
`;

export default () => (
  <Wrapper>
    <Spinner sizePx={20} />
  </Wrapper>
);
